  function openTab(index) {
    const tabs = document.querySelectorAll('.tab');
    const contents = document.querySelectorAll('.tab-content');

    tabs.forEach((tab, i) => {
      tab.classList.toggle('active', i === index);
      contents[i].classList.toggle('active', i === index);
    });
  }

document.querySelectorAll('.footer-block').forEach((block, index) => {
  block.addEventListener('click', function () {

    if (index === 2) return;

    const isActive = block.classList.contains('active');

    document.querySelectorAll('.footer-block').forEach(item =>
      item.classList.remove('active')
    );

    if (!isActive) {
      block.classList.add('active');
    }
  });
});



$('.main_testi_slider').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 2.5,
  slidesToScroll: 1,
  appendArrows: $('.slick_button_mai_new'), // place arrows inside this div
  prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">' +
               '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">' +
                 '<path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>' +
               '</svg>' +
             '</button>',
  nextArrow: '<button type="button" class="slick-next" aria-label="Next">' +
               '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">' +
                 '<path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/>' +
               '</svg>' +
             '</button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        appendArrows: $('.slick_button_mai_new')
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        appendArrows: $('.slick_button_mai_new')
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        appendArrows: $('.slick_button_mai_new')
      }
    }
  ]
});


$('.image_with_text_slider').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 1.7,
  slidesToScroll: 1,
   appendArrows: $('.slick_button_mai_new_call'),
     prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">' +
               '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">' +
                 '<path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>' +
               '</svg>' +
             '</button>',
  nextArrow: '<button type="button" class="slick-next" aria-label="Next">' +
               '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">' +
                 '<path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/>' +
               '</svg>' +
             '</button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
  infinite: false,
  arrows: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});